module.exports = __webpack_public_path__ + "static/img/preview_analytics.1a3a142.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v7/preview_analytics.jpg
// module id = Mgzz
// module chunks = 0